import React from 'react'
import LandingPage from '../Components/LandingPage/LandingPage'
import NavBar from '../Components/NavBar/NavBar'
import AboutUs from '../Components/AboutUs/AboutUs'
import Services from '../Components/Services/Services'
import Testimonials from '../Components/Testimonials/Testimonials'
import Footer from '../Components/Footer/Footer'

const Home = () => {
    return (
        <div>
            <NavBar />
            <LandingPage />
            <AboutUs />
            <Services />
            <Testimonials />
            <Footer />
        </div>
    )
}

export default Home